import { commonComponents as cc } from "@/components/common";
import { cn } from "@/lib/utils";
import { services as s } from "@/services";
import type { ExtendedEventViewT } from "@/types/database/events";

import {
	type SharedAttributeJSON,
	SharedAttributesT,
} from "../../../types/database/diaries";
import { useAuth } from "../../../utils/auth";
import SharedAttributeDatePicker from "../../shared_attributes/components/SharedAttributeDatePicker";
import DeleteEventButton from "./DeleteEventButton";
import EventSwitches from "./EventSwitches";

interface Props {
	event: ExtendedEventViewT;
}
const EditEvent = ({ event }: Props) => {
	return (
		<>
			<cc.EditDialog
				label="Procedure Date"
				info={s.time.formatShortDateTime(
					event.shared_attributes?.reference_date,
				)}
				noInfo={!event.shared_attributes?.reference_date}
			>
				<SharedAttributeDatePicker
					dateType="reference_date"
					sharedAttributes={event
						.shared_attributes as SharedAttributeJSON}
				/>
			</cc.EditDialog>

			<EventSwitches event={event} />
		</>
	);
};

export default EditEvent;
